import React from 'react'

const StoreLeads = () => {
    return (
        <div>StoreLeads</div>
    )
}

export default StoreLeads